import { useState } from "react";
import { useTheme } from "../App";

function KVEditor({ rows, onChange }) {
  const { C, accent } = useTheme();
  const upd = (i,f,v) => onChange(rows.map((r,idx)=>idx===i?{...r,[f]:v}:r));
  const add  = () => onChange([...rows,{ key:"",value:"",enabled:true }]);
  const del  = (i) => onChange(rows.filter((_,idx)=>idx!==i));
  return (
    <div style={{ padding:"10px 0" }}>
      {rows.map((r,i)=>(
        <div key={i} style={{ display:"flex", gap:8, alignItems:"center", marginBottom:7, opacity:r.enabled?1:0.45 }}>
          <input type="checkbox" checked={r.enabled} onChange={()=>upd(i,"enabled",!r.enabled)}
            style={{ accentColor:accent, cursor:"pointer", flexShrink:0 }}/>
          <input value={r.key} onChange={e=>upd(i,"key",e.target.value)} placeholder="Key"
            style={{ flex:1, background:C.bg, border:`1px solid ${C.border}`, borderRadius:5,
              padding:"5px 9px", color:C.text, fontSize:12, outline:"none", fontFamily:"monospace" }}
            onFocus={e=>e.target.style.borderColor=accent} onBlur={e=>e.target.style.borderColor=C.border}/>
          <input value={r.value} onChange={e=>upd(i,"value",e.target.value)} placeholder="Value"
            style={{ flex:2, background:C.bg, border:`1px solid ${C.border}`, borderRadius:5,
              padding:"5px 9px", color:"#79c0ff", fontSize:12, outline:"none", fontFamily:"monospace" }}
            onFocus={e=>e.target.style.borderColor=accent} onBlur={e=>e.target.style.borderColor=C.border}/>
          <button type="button" onClick={()=>del(i)} style={{ background:"none", border:"none",
            color:"#f85149", cursor:"pointer", fontSize:16, padding:"0 4px", opacity:0.5 }}
            onMouseEnter={e=>e.currentTarget.style.opacity="1"}
            onMouseLeave={e=>e.currentTarget.style.opacity="0.5"}>×</button>
        </div>
      ))}
      <button type="button" onClick={add} style={{ background:"none", border:"none",
        color:"#388bfd", cursor:"pointer", fontSize:12, padding:"4px 0", fontWeight:600 }}>+ Add row</button>
    </div>
  );
}

export default function EnvPanel({ env, onChange, onClose }) {
  const { C, accent } = useTheme();
  const [rows, setRows] = useState(Object.entries(env).map(([key,value])=>({ key,value,enabled:true })));

  const sync = newRows => {
    setRows(newRows);
    const out = {};
    newRows.filter(r=>r.enabled&&r.key).forEach(r=>{ out[r.key]=r.value; });
    onChange(out);
  };

  return (
    <div style={{ position:"absolute", top:52, right:16, zIndex:300, width:440,
      background:C.panel, border:`1px solid ${C.border}`, borderRadius:10,
      boxShadow:"0 12px 40px #00000088" }}>
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between",
        padding:"12px 16px", borderBottom:`1px solid ${C.border}` }}>
        <div>
          <div style={{ fontSize:13, fontWeight:700, color:C.text }}>Environment Variables</div>
          <div style={{ fontSize:11, color:C.muted, marginTop:3 }}>
            Use <code style={{ background:C.bg, padding:"1px 5px", borderRadius:3,
              color:"#79c0ff", fontFamily:"monospace" }}>{"{{variable}}"}</code> in your URLs
          </div>
        </div>
        <button type="button" onClick={onClose} style={{ background:"none", border:"none",
          color:C.muted, cursor:"pointer", fontSize:20, lineHeight:1 }}>×</button>
      </div>
      <div style={{ padding:"8px 16px 16px" }}>
        <KVEditor rows={rows} onChange={sync}/>
        <button type="button" className="btn btn-primary" onClick={onClose} style={{ marginTop:8, padding:"8px 20px" }}>Save & Close</button>
      </div>
    </div>
  );
}
